import { ADD_EVALUATION_ASSESSORS } from '../../../constants/api'
import errorHandler from '../errorHandler'
import { IEvaluationAssessorsUpdateRequest } from '../../../common/models/Evaluation'

export default (
  evaluationId: string,
  assessors: IEvaluationAssessorsUpdateRequest,
  token: string
) =>
  fetch(ADD_EVALUATION_ASSESSORS(evaluationId), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(assessors),
  })
    .then(errorHandler)
    .then((e) => e)
